module.exports = __webpack_public_path__ + "media/stop.94b97d11.wav";